import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Datepicker from "../../../vendor/vuejs-datepicker/components/Datepicker.vue";
import _startsWith from "lodash/startsWith";
import * as allLang from "../../../vendor/vuejs-datepicker/locale/index.js";

import tabList from './tabList.vue';

import { createApp } from 'vue'

Vue.use(VueAxios, axios);

const siteConfig = {};
Object.assign(siteConfig, window.merlinConfig);
let language = siteConfig.i18n.locale;
if (language === 'pt')
   language = 'ptBR';

var lang = allLang[language];
if (lang === undefined) 
    lang = allLang['en'];

if (document.getElementById("calendar-app")) {

    const calendarApp = createApp({
        data() {
            return {
                locations: [],
                activeLocation: null,
                footerMessage: null,
                footerPosition: null,
                mondayFirst: true,
                showdatepicker: false,
                lastRowIsSelected: false,
                closedText: "Closed",
                lang: lang,
                days: {
                    short: lang._days,
                    long: []
                },
                months: lang._months,
                tabListData: null,
                highlighted: {
                    days: [0, 6], // Highlight Saturday's and Sunday's
                    includeDisabled: true
                },
                disabledDates: {
                    to: new Date("2019-11-07T00:00:00+01:00"),
                    from: new Date("2020-02-04T00:00:00")
                },
                dateIsSelected: false
            }
		},
        async created() {			
            let { data } = await this.$http.get(`${siteConfig.urlPrefix}/api/openinghours/getcalendar?lang=${siteConfig.i18n.culture}&locationIds=${window.locationIds}`);

			if (data.firstDayOfWeekIsSunday) {
				this.mondayFirst = false;
			} else {
				this.mondayFirst = true;
			}
			this.days.long = data.weekdayLocalizations;
			this.showdatepicker = true;
            this.disabledDates.to = new Date(data.startDate);
            this.disabledDates.from = new Date(data.endDate);
            this.locations = data.locations;
            this.setTabListData(data);
            this.closedText = data.closedText;
            this.highlighted.days = data.highlightDays;
            this.$nextTick(() => {
                if (this.$el) {
                    this.handleSvgIcons();
                }
            });
        },
        computed: {
            showCellFooter() {
                return this.dateIsSelected && this.footerMessage;
            },
            canShowButton() {
                return this.activeLocation && this.activeLocation.hasOwnProperty('cta') && this.activeLocation.cta != '';
            },
        },
        mounted() {
            this.bindCellEvents();
            window.addEventListener('resize', this.onResize);
        },

        methods: {
            setTabListData: function (data) {
                this.tabListData = data.locations.map((location, index) => {
                    let obj = {};
                    obj.locationName = location.locationName;
                    obj.locationId = location.locationId;

                    obj.days = location.days;
                    if (location.cta) {
                        obj.cta = location.cta;
                    }
                    if (
                        obj.cta &&
                        obj.cta.toString().includes("data-accesso-package")
                    ) {
                    }
                    if (index === 0) {
                        obj.active = true;
                        this.activeLocation = obj;
                    } else {
                        obj.active = false;
                    }

                    return obj;
                });
            },
            handleSubmit(e) {
                return;
            },
            setCells(x) {
                const today = new Date(x.timestamp);
                const stringDate = this.getStringDate(today);
                var startDateIndex = stringDate;

                let currentDayInCell;

                currentDayInCell = this.activeLocation.days
                    .filter(({ key }) => {
                        let calendarDay = startDateIndex.substring(0, 6); //e.g., "201910"
                        return _startsWith(key, calendarDay); //e.g., ("20191001", "201910")
                    })
                    .find(current => {
                        //find the specific day in the filtered days
                        return current.key === startDateIndex;
                    });

                if (currentDayInCell && currentDayInCell.key === stringDate) {
                    //not closed

                    let ctaHtml = '';

                    if (this.activeLocation && this.activeLocation.cta) {
                        ctaHtml = `<div class="cell-footer-cta">${this.activeLocation && this.activeLocation.cta}</div>`
                    }

                    return `<div class="cell-content-wrapper ${currentDayInCell.message && 'has-message'}">
								<div class="cell-day-wrapper">
									<span class="cell-day">${x.date}</span>
									<span class="cell-weekday">${this.getWeekDay(today)}</span>
								</div>
								<div class="cell-hours-wrapper">
									<span class="cell-hours">${currentDayInCell.openingHours}</span>
									<span class="cell-entry">${currentDayInCell.rideOpeningHours || ''}</span>
									<span class="cell-entry">${currentDayInCell.lastEntryTime || ''}</span>
								</div>
								<span class="cell-expand">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 20" width="16" height="16" aria-hidden="true" focusable="false">
										<path fill="#000" d="M16 12.318L27.333.796c1.043-1.061 2.735-1.061 3.778 0 1.043 1.061 1.043 2.78 0 3.841L16 20 .888 4.637C-.155 3.576-.155 1.857.888.796c1.043-1.061 2.735-1.061 3.778 0L16 12.318z"></path>
									</svg>
								</span>
								<div class="cell-footer">
									<div class="cell-footer-message">
										${currentDayInCell.message}
									</div>

                                    ${ctaHtml}
								</div>
							</div>`;

                } else {
                    return `<div class="cell-content-wrapper closed">
								<div class="cell-day-wrapper">
									<span class="cell-day">${x.date}</span>
									<span class="cell-weekday">${this.getWeekDay(today)}</span>
								</div>
								<div class="cell-hours-wrapper">
									<strong class="cell-hours">${this.closedText}</strong>
								</div>
                        	</div>`;
                }
            },

            getWeekDay(date) {
                return this.days.long[date.getDay()];
            },
            handleSelect(date) {
                this.dateIsSelected = true;
                this.buildFooterDate(date);
            },
            changedMonth(event) {
                this.dateIsSelected = false;
            },
            resetCellStyles() {
                document.querySelectorAll('.day').forEach(item => { item.classList.remove('is-active') });
                this.dateIsSelected = false;
                this.lastRowIsSelected = false;

            },
            closeCell(event) {
                event.stopPropagation();
                this.resetCellStyles();
            },
            bindCellEvents() {
                document.querySelector('.datepicker-container').addEventListener('click', this.handleCellClick);
                document.querySelector('.calendar-footer-close').addEventListener('click', this.closeCell);
            },
            getNextSibling(elem, selector) {
                if (elem.matches(selector)) return elem;
                var sibling = elem.nextElementSibling;
                while (sibling) {
                    if (sibling.matches(selector)) return sibling;
                    sibling = sibling.nextElementSibling;
                }
            },
            handleCellClick(event) {
                this.dateIsSelected = false;

                if (event.target.matches('.prev, .next')) {
                    return this.changedMonth();
                }

                event.target.parentNode.classList.toggle('is-active');

                if (window.innerWidth > 640) {
                    let blackList = ['disabled', 'blank', 'day-header'];
                    if (event.target.parentNode.classList.contains('day') && !blackList.some(className => event.target.parentNode.classList.contains(className))) {
                        let nextWeekend = this.mondayFirst ? this.getNextSibling(event.target.parentNode, '.sun') : this.getNextSibling(event.target.parentNode, '.sat');
                        let allDays = event.target.parentNode.parentNode.querySelectorAll('.cell');
                        let nextWeekendIsLast = nextWeekend && nextWeekend === allDays[allDays.length - 1];
                        if (nextWeekend) {
                            nextWeekend.insertAdjacentElement('afterend', this.$refs.calendarfooter);
                        } else {
                            event.target.parentNode.parentNode.insertAdjacentElement('beforeend', this.$refs.calendarfooter);
                        }
                        this.lastRowIsSelected = nextWeekendIsLast !== undefined ? nextWeekendIsLast : true;
                        this.dateIsSelected = true;
                    }
                } else {
                    this.lastRowIsSelected = event.target.parentNode.matches('.is-active') && event.target.parentNode === event.target.parentNode.parentNode.lastChild;
                    this.dateIsSelected = true;
                }

                return true;
            },
            getStringDate(date) {
                const year = date.getFullYear();
                const month = `${date.getMonth() + 1}`.padStart(2, 0);
                const day = `${date.getDate()}`.padStart(2, 0);
                const stringDate = [year, month, day].join("");
                return stringDate;
            },
            buildFooterDate(date) {
                const stringDate = this.getStringDate(date);

                let currentLocation = this.tabListData.filter(tab => {
                    return tab.active === true;
                });

                let footerDay = currentLocation[0].days.filter(day => {
                    return day.key === stringDate;
                });

                this.footerMessage =
                    footerDay[0] && footerDay[0].message
                        ? footerDay[0].message
                        : "";

            },
            handleActiveTab: function (tab) {
                this.activeLocation = tab;
                this.dateIsSelected = false;
            },

            handleSvgIcons: function () {
                if (this.$el) {
                    const arrow = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="20" viewBox="0 0 32 20" aria-hidden="true" focusable="false">
                                      <path d="M16 12.318L27.333.796c1.043-1.061 2.735-1.061 3.778 0 1.043 1.061 1.043 2.78 0 3.841L16 20 .888 4.637C-.155 3.576-.155 1.857.888.796c1.043-1.061 2.735-1.061 3.778 0L16 12.318z"/>
                                    </svg>`;

                    const prev = document.querySelector(
                        ".vdp-datepicker.is-active .vdp-datepicker__calendar header .prev"
                    );
                    const next = document.querySelector(
                        ".vdp-datepicker.is-active .vdp-datepicker__calendar header .next"
                    );

					prev.innerHTML = next.innerHTML = "";
					prev.innerHTML = next.innerHTML = arrow;
				}
			},
			onResize() {
				this.resetCellStyles();
				this.dateIsSelected = false;
			},
		},
		updated() {            
            this.$nextTick(() => {
                this.handleSvgIcons();
            });

			let buttons = document.querySelectorAll("#calendar-app button");
			buttons.forEach(button => {
				if (button && button.classList.contains("accesso")) {
                    try {
                        window.accesso.reinitializeHooks();
					} catch (e) {
                        console.log("Acesso object not ready yet!");
                    }

                }
			});
		},
		components: {
			tabList,
			Datepicker
		}
	});

    calendarApp.mount('#calendar-app')
}
